import Spacer, {
  ESpacerWeight,
} from "@rentiohq/shared-frontend/dist/components/components/Spacer";
import { IExtraChecklistItem } from "@rentiohq/shared-frontend/dist/reduxV2/preferences/preference.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { TextField } from "@rentiohq/web-shared/dist/components";
import * as S from "./ChecklistItem.styles";

interface IProps {
  item: IExtraChecklistItem;
  enabled: boolean;
  errors: { title?: string; description?: string };
  onDragStart: () => void;
  onDragEnter: () => void;
  onDragEnd: () => void;
  onItemChange: (field: "title" | "description", value: string) => void;
  onRemove: () => void;
}

export const ChecklistItem = ({
  item,
  enabled,
  errors,
  onDragStart,
  onDragEnter,
  onDragEnd,
  onItemChange,
  onRemove,
}: IProps) => (
  <S.DraggableItem
    draggable={enabled}
    onDragStart={() => enabled && onDragStart()}
    onDragEnter={() => enabled && onDragEnter()}
    onDragEnd={() => enabled && onDragEnd()}
    onDragOver={e => e.preventDefault()}
  >
    <S.DragHandle
      title={getLocalizedText("settings.checklist.item.drag")}
      isDisabled={!enabled}
    >
      ⠿
    </S.DragHandle>
    <S.ItemFields>
      <TextField
        name={`label-${item.index}`}
        label={`${getLocalizedText("settings.checklist.item.title")} (max 30)`}
        value={item.title}
        maxLength={30}
        disabled={!enabled}
        error={errors.title}
        onChange={({ target: { value } }: { target: { value: string } }) =>
          onItemChange("title", value)
        }
      />
      <Spacer weight={ESpacerWeight.W08} />
      <TextField
        name={`description-${item.index}`}
        label={`${getLocalizedText(
          "settings.checklist.item.description",
        )} (max 60)`}
        value={item.description}
        maxLength={60}
        disabled={!enabled}
        error={errors.description}
        onChange={({ target: { value } }: { target: { value: string } }) =>
          onItemChange("description", value)
        }
      />
    </S.ItemFields>
    <S.RemoveButton
      onClick={onRemove}
      title={getLocalizedText("settings.checklist.item.remove")}
      disabled={!enabled}
    >
      ✕
    </S.RemoveButton>
  </S.DraggableItem>
);
